import React, { useRef } from 'react'
import { Dialog, DialogProps, styled } from '@mui/material'
import useOutsideClick from './useOutsideClick'

const StyledDialog = styled(Dialog)(({ theme }) => ({
    pointerEvents: 'none',
    '& .MuiDialog-paper': {
        pointerEvents: 'auto'
    }
}))

const CustomDialog: React.FC<DialogProps> = ({
                                                 children,
                                                 onClose,
                                                 ...dialogProps
                                             }) => {
    const wrapperRef = useRef<HTMLDivElement>(null)

    useOutsideClick(wrapperRef, () => {
        onClose?.(null as any, 'backdropClick')
    })

    return (
        <StyledDialog {...dialogProps} onClose={onClose}>
            <div ref={wrapperRef}>
                {children}
            </div>
        </StyledDialog>
    )
}

export default CustomDialog
